import { Component, Inject, ElementRef, ViewChild } from '@angular/core';
import { CMSPortalService } from '../../shared/service/cms-portal.service';
import { Router } from '@angular/router';
import { Evento } from '../../shared/model/evento.model';
import { CarouselConfig } from 'ngx-bootstrap';

@Component({
  selector: 'app-conteudo-slider-eventos',
  templateUrl: './sliderEventos.component.html',
  styleUrls: ['./sliderEventos.component.css'],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 1500, noPause: true, showIndicators: false } }
  ]
})
export class SliderEventosComponent {

  @ViewChild('Fader') slideEL: ElementRef;
  public listaEventos: Evento[] = [];
  public eventoSelecionado: Evento;

  constructor(private service: CMSPortalService,
              private router: Router,
              @Inject('CMS_HOST') private host: string) {
    this.getSlider();
  }

  getSlider() {
    this.service.getSlideEvento().subscribe(res => {
      this.listaEventos = res.conteudo;
    });
  }

  buscaImagem(evento: Evento): string {
    return this.host + evento.imagem.url;
  }

  abrirDetalheEvento(evento: number) {
    const fragment = document.createRange().createContextualFragment(
      '<script type="text/javascript">' +
        'abrirModalEvento(' + evento + ')' +
      '</script>');
    this.slideEL.nativeElement.appendChild(fragment);
  }

}
